import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    Renderer2,
    inject
} from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import uniq from 'lodash-es/uniq';
import { Product } from '../../../catalog/product/product.decorator';
import { ReviewsIOService } from '../reviews-io.service';

let uid = 0;
@Component({
    selector: 'reviews-io-rating',
    template: `<div [ngClass]="className" [attr.data-sku]="productsSKUs"></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                height: 1em;
                display: block;
                visibility: hidden;
                &._loaded {
                    height: fit-content;
                    visibility: visible;
                }
                ::ng-deep {
                    .ruk_rating_snippet i {
                        font-size: 1em;
                    }
                    .ruk-rating-snippet-count {
                        margin-left: 8px;
                    }
                }
                &._biggerStars ::ng-deep {
                    > div {
                        display: flex;
                        align-items: center;
                        gap: 2px;
                    }
                    .ruk_rating_snippet i,
                    i[class*='ruk-icon-percentage-star'] {
                        font-size: 1rem;
                    }
                    .ruk-rating-snippet-count {
                        line-height: 1.5em;
                        margin-left: 6px;
                    }
                }
            }
        `
    ]
})
export class ReviewsIORatingComponent implements AfterViewInit, OnDestroy {
    @Input({ required: true })
    product!: Product;

    @Input()
    theme: 'gold' | 'default' = 'default';

    @Input()
    @HostBinding('class._biggerStars')
    biggerStars: boolean = false;

    private reviewsIOService = inject(ReviewsIOService);
    private renderer2 = inject(Renderer2);
    private timeoutService = inject(TimeoutService);
    private elementRef = inject(ElementRef);

    protected uid = uid++;
    protected className = `reviews-io-rating-${this.uid}`;
    private timeoutId?: number;

    ngAfterViewInit(): void {
        this.reviewsIOService.updateRatingSnippet(this.className, this.theme === 'gold' ? { color: '#FFC314' } : {});
        this.timeoutId = this.timeoutService.setTimeout(() => {
            this.renderer2.addClass(this.elementRef.nativeElement, '_loaded');
        }, 500);
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeoutId);
    }

    get productsSKUs(): string {
        return uniq(
            (this.product.children?.length
                ? [this.product.data?.sku, ...this.product.children.map(p => p.data?.sku)]
                : [this.product.data?.sku]
            ).filter(p => p !== undefined)
        ).join(';');
    }
}
